// extracted by mini-css-extract-plugin
export default {"cards":"TraitScoreCards-module__cards__kbXA0","card":"TraitScoreCards-module__card__suszv"};